// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { PreparingForUseService } from '../../preparing-for-use.service';
import { RegistrationPreparationForUse, RegistrationPreparationForUseSuccess } from './preparing-for-use.actions';
import { PREPARING_FOR_USE_STATE_DEFAULT, PreparingForUseStateModel } from './preparing-for-use.model';

@State({ name: 'PreparingForUse', defaults: PREPARING_FOR_USE_STATE_DEFAULT })
@Injectable()
export class PreparingForUseState {

  constructor(private preparingForUseService: PreparingForUseService) {
  }

  @Selector()
  static registrationStatus(state: PreparingForUseStateModel): PreparingForUseStateModel['registrationStatus'] {
    return state.registrationStatus;
  }

  @Action(RegistrationPreparationForUse)
  registration(ctx: StateContext<PreparingForUseStateModel>, { data }: RegistrationPreparationForUse): void {
    ctx.patchState({
      registrationStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.preparingForUseService.registration(data).subscribe({
      next: (res) => ctx.dispatch(new RegistrationPreparationForUseSuccess(res)),
      error: () => {
        ctx.patchState({
          registrationStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }

  @Action(RegistrationPreparationForUseSuccess)
  registrationSuccess(ctx: StateContext<PreparingForUseStateModel>, { data }: RegistrationPreparationForUseSuccess): void {
    ctx.patchState({
      registrationStatus: PROGRESS_STATUSES.SUCCESS
    });
  }
}


